import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CustomerSelectionOption } from '@app/customer/models/customer-selection-option.model';
import { CustomerBankAccount } from '@usf/payment-types';
import { BankToggleOptions } from './bank-toggle-options.enum';

@Component({
  selector: 'app-segments-bank-account',
  templateUrl: './segments-bank-account.component.html',
  styleUrls: ['./segments-bank-account.component.scss'],
})
export class SegmentsBankAccountComponent {
  @Input() showSegments = true;
  @Input() isSettingUpAutopay = false;
  @Input() isPrimaryByDefault = false;
  @Input() isEditingAutopay = false;
  @Input() isEditingBankAccount = false;
  @Input() canSelectCustomers = false;
  @Input() bankAccounts: CustomerBankAccount[];
  @Input() selectedSegment: string;
  @Input() isDesktop: boolean;
  @Input() addBankAccountForm: FormGroup;
  @Input() canModifyForm: boolean;
  @Input() selectedCustomers: CustomerSelectionOption[];
  @Input() selectedBankAccount: CustomerBankAccount;
  @Input() isBankRoutingValidationOn: boolean;
  @Output() isLoadingEmit: EventEmitter<boolean> = new EventEmitter();
  @Output() setSelectedSegmentEmit = new EventEmitter<BankToggleOptions>();
  @Output() selectBankAccountEmitter = new EventEmitter<CustomerBankAccount>();
  @Output() submitFormEmitter = new EventEmitter<void>();

  toggleOptions = BankToggleOptions;
  constructor() {}

  setSelectedSegment(event) {
    if (event?.detail) {
      this.setSelectedSegmentEmit.emit(event.detail.value);
    }
  }

  selectBankAccount(bankAccount: CustomerBankAccount) {
    this.selectBankAccountEmitter.emit(
      bankAccount.bankID !== this.selectedBankAccount?.bankID
        ? bankAccount
        : null,
    );
  }

  isFormLoading(isLoading: boolean) {
    this.isLoadingEmit.emit(isLoading);
  }

  submitForm() {
    this.submitFormEmitter.emit();
  }
}
